import { SvgIcon, SvgIconProps } from "@mui/material";

export const LogoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="139" height="36" viewBox="0 0 139 36" fill="none">
      <path
        d="M15.776 3.45919C12.1248 3.42256 8.47457 3.60468 4.8414 4.00476C4.25134 4.03337 3.69356 4.30919 3.28224 4.77575C2.87092 5.24231 2.63719 5.8643 2.62891 6.51436C2.63684 10.7917 2.54663 20.0728 3.89474 23.4957C5.18599 26.0091 6.84825 28.2685 8.81338 30.181C10.2448 31.5363 13.7092 34 15.776 34C17.8428 34 21.3072 31.5308 22.7396 30.181C24.7048 28.2685 26.3671 26.0091 27.6582 23.4957C29.0034 20.0816 28.823 10.8385 28.9231 6.5471C28.9106 5.89516 28.673 5.27294 28.2588 4.80682C27.8445 4.3407 27.2846 4.06562 26.6927 4.03749C23.0652 3.63941 19.4215 3.44639 15.776 3.45919Z"
        fill="#106048"
      />
      <path d="M9.00098 14.9086V18.1101L10.5681 16.9633V13.7607L9.00098 14.9086Z" fill="white" />
      <path d="M6.95508 21.0091V24.2105L8.52227 23.0637V19.8623L6.95508 21.0091Z" fill="white" />
      <path
        d="M17.1978 16.522V17.9241L13.2329 20.8266V24.0279L23.8394 16.2656C24.351 15.9031 24.7898 15.4289 25.1285 14.8725C25.4672 14.3161 25.6989 13.6891 25.809 13.0304C25.9381 12.3763 25.9442 11.7 25.8269 11.0432C25.7096 10.3864 25.4714 9.763 25.127 9.2114C24.7979 8.64789 24.3675 8.16457 23.8621 7.7913C23.3568 7.41803 22.7873 7.16272 22.1889 7.04112C21.5947 6.89891 20.9803 6.89215 20.3835 7.02126C19.7869 7.15036 19.2205 7.41261 18.7194 7.79183L11.631 12.9846V16.1859L15.6782 13.2246V14.6267L9.58301 19.0862V22.0988L17.1978 16.522Z"
        fill="white"
      />
      <path d="M10.6016 22.7513V25.9526L12.1688 24.8058V21.6045L10.6016 22.7513Z" fill="white" />
      <path
        d="M56.0819 17.8754V27.6608C55.2102 28.1336 54.1847 28.5023 53.0054 28.767C51.8261 29.0318 50.6126 29.1641 49.365 29.1641C47.4507 29.1641 45.7929 28.7576 44.3914 27.9445C42.99 27.1125 41.9132 25.9307 41.1612 24.399C40.4091 22.8485 40.0332 21.0143 40.0332 18.8965C40.0332 16.8165 40.4006 15.0107 41.1356 13.479C41.8876 11.9285 42.9558 10.7373 44.3401 9.90521C45.7245 9.07323 47.3396 8.65723 49.1855 8.65723C50.4844 8.65723 51.6894 8.85577 52.8003 9.25286C53.9283 9.64994 54.8598 10.1984 55.5947 10.8979L54.3385 14.0463C53.501 13.3845 52.6807 12.9118 51.8773 12.6281C51.0912 12.3256 50.2366 12.1743 49.3137 12.1743C45.8271 12.1743 44.0838 14.415 44.0838 18.8965C44.0838 21.2034 44.5367 22.9241 45.4425 24.0587C46.3484 25.1932 47.7156 25.7605 49.5444 25.7605C50.5358 25.7605 51.5185 25.6187 52.4927 25.335V20.9387H48.9548V17.8754H56.0819Z"
        fill="black"
      />
      <path
        d="M65.2154 29.1359C63.8823 29.1359 62.7115 28.8428 61.7031 28.2566C60.6947 27.6516 59.9171 26.8101 59.3702 25.7323C58.8233 24.6356 58.5498 23.3497 58.5498 21.8748C58.5498 20.3999 58.8233 19.1235 59.3702 18.0457C59.9171 16.9491 60.6947 16.1076 61.7031 15.5214C62.7115 14.9352 63.8823 14.6421 65.2154 14.6421C66.5485 14.6421 67.7193 14.9352 68.7277 15.5214C69.7361 16.1076 70.5137 16.9491 71.0606 18.0457C71.6075 19.1235 71.881 20.3999 71.881 21.8748C71.881 23.3497 71.6075 24.6356 71.0606 25.7323C70.5137 26.8101 69.7361 27.6516 68.7277 28.2566C67.7193 28.8428 66.5485 29.1359 65.2154 29.1359ZM65.2154 25.8741C67.0955 25.8741 68.0355 24.541 68.0355 21.8748C68.0355 20.5323 67.7876 19.5301 67.292 18.8683C66.8134 18.2065 66.1213 17.8755 65.2154 17.8755C63.3354 17.8755 62.3954 19.2086 62.3954 21.8748C62.3954 24.541 63.3354 25.8741 65.2154 25.8741Z"
        fill="black"
      />
      <path
        d="M79.8265 14.6421C81.7062 14.6421 83.0907 15.1338 83.9792 16.117C84.885 17.1003 85.3384 18.6225 85.3384 20.6835V28.909H81.6723V26.8385C81.4156 27.5571 80.9883 28.1243 80.3904 28.5403C79.7918 28.9374 79.0913 29.1359 78.288 29.1359C77.4334 29.1359 76.6558 28.9469 75.955 28.5686C75.2714 28.1905 74.7245 27.661 74.3143 26.9803C73.9212 26.2995 73.7246 25.5432 73.7246 24.7112C73.7246 23.6901 73.9554 22.8865 74.4168 22.3003C74.8954 21.7141 75.6559 21.2887 76.6985 21.0239C77.7411 20.7592 79.1679 20.6268 80.9796 20.6268H81.6462V20.1163C81.6462 19.2843 81.4843 18.6981 81.1597 18.3577C80.8343 18.0174 80.2704 17.8472 79.4672 17.8472C78.852 17.8472 78.1683 17.9701 77.4163 18.2159C76.6643 18.4618 75.9465 18.8021 75.2629 19.237L74.2373 16.3723C74.9552 15.8807 75.8354 15.4741 76.8779 15.1526C77.9376 14.8123 78.9204 14.6421 79.8265 14.6421ZM79.1339 26.1861C79.8858 26.1861 80.4931 25.912 80.9543 25.3635C81.4156 24.7963 81.6462 24.0683 81.6462 23.1795V22.6974H81.2102C79.8266 22.6974 78.852 22.8203 78.288 23.0661C77.7411 23.3119 77.4676 23.7563 77.4676 24.3992C77.4676 24.9097 77.6214 25.3352 77.929 25.6755C78.2538 26.0159 78.6554 26.1861 79.1339 26.1861Z"
        fill="black"
      />
      <path d="M88.2314 28.9089V8.9126H92.1029V28.9089H88.2314Z" fill="black" />
      <path
        d="M102.964 14.6421C104.467 14.6421 105.586 15.1338 106.322 16.117C107.057 17.0814 107.424 18.5468 107.424 20.5134V28.909H103.553V20.7119C103.553 19.7665 103.391 19.0763 103.065 18.6414C102.758 18.2065 102.271 17.989 101.604 17.989C100.801 17.989 100.152 18.2726 99.656 18.8399C99.1774 19.4072 98.9381 20.1636 98.9381 21.109V28.909H95.0674V14.9825H98.8354V16.9679C99.28 16.2116 99.8526 15.6348 100.553 15.2377C101.271 14.8406 102.074 14.6421 102.964 14.6421Z"
        fill="black"
      />
      <path
        d="M123.158 14.9825V27.4057C123.158 29.656 122.576 31.3578 121.415 32.5112C120.252 33.6647 118.534 34.2414 116.261 34.2414C115.133 34.2414 114.048 34.0901 113.005 33.7875C111.98 33.4851 111.074 33.0596 110.288 32.5112L111.313 29.5614C112.937 30.5447 114.552 31.0363 116.159 31.0363C118.278 31.0363 119.337 29.9301 119.337 27.7177V26.1861C118.979 26.9047 118.44 27.472 117.722 27.8879C117.004 28.3039 116.201 28.5119 115.313 28.5119C114.219 28.5119 113.244 28.2283 112.39 27.661C111.553 27.0937 110.895 26.2901 110.416 25.2501C109.938 24.1912 109.698 22.9716 109.698 21.5912C109.698 20.2109 109.938 19.0007 110.416 17.9606C110.895 16.9018 111.553 16.0886 112.39 15.5214C113.244 14.9352 114.219 14.6421 115.313 14.6421C116.185 14.6421 116.97 14.8501 117.671 15.2661C118.389 15.6632 118.936 16.221 119.312 16.9395V14.9825H123.158ZM116.441 25.2501C117.346 25.2501 118.047 24.9287 118.543 24.2857C119.055 23.6429 119.312 22.7447 119.312 21.5912C119.312 20.4378 119.055 19.5396 118.543 18.8966C118.047 18.2348 117.346 17.9039 116.441 17.9039C115.535 17.9039 114.825 18.2348 114.313 18.8966C113.8 19.5396 113.544 20.4378 113.544 21.5912C113.544 22.7257 113.8 23.6239 114.313 24.2857C114.825 24.9287 115.535 25.2501 116.441 25.2501Z"
        fill="black"
      />
      <path
        d="M132.186 29.1359C130.853 29.1359 129.683 28.8428 128.674 28.2566C127.666 27.6516 126.889 26.8101 126.341 25.7323C125.795 24.6356 125.521 23.3497 125.521 21.8748C125.521 20.3999 125.795 19.1235 126.341 18.0457C126.889 16.9491 127.666 16.1076 128.674 15.5214C129.683 14.9352 130.853 14.6421 132.186 14.6421C133.52 14.6421 134.691 14.9352 135.699 15.5214C136.707 16.1076 137.485 16.9491 138.031 18.0457C138.579 19.1235 138.852 20.3999 138.852 21.8748C138.852 23.3497 138.579 24.6356 138.031 25.7323C137.485 26.8101 136.707 27.6516 135.699 28.2566C134.691 28.8428 133.52 29.1359 132.186 29.1359ZM132.186 25.8741C134.067 25.8741 135.007 24.541 135.007 21.8748C135.007 20.5323 134.759 19.5301 134.263 18.8683C133.785 18.2065 133.092 17.8755 132.186 17.8755C130.307 17.8755 129.367 19.2086 129.367 21.8748C129.367 24.541 130.307 25.8741 132.186 25.8741Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="#707070"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ChatIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BellIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8187 2.8174C13.9651 2.3997 13.0074 2.1665 12.0002 2.1665C8.72907 2.1665 5.98104 4.6261 5.6198 7.87723L5.368 10.1434C5.33199 10.4675 5.3167 10.6033 5.2957 10.7351C5.19295 11.3802 4.98256 12.0035 4.67331 12.5789C4.61014 12.6965 4.54005 12.8137 4.37227 13.0933L3.79424 14.0567L3.76325 14.1084C3.45692 14.6188 3.18045 15.0794 3.01936 15.4668C2.85073 15.8722 2.7097 16.4261 3.01501 16.9758L3.02846 16.9995C3.34274 17.5441 3.89024 17.7082 4.32467 17.7722C4.73966 17.8333 5.27692 17.8332 5.8722 17.8332L5.93243 17.8332H18.068L18.1282 17.8332C18.7235 17.8332 19.2607 17.8333 19.6757 17.7722C20.1102 17.7082 20.6577 17.5441 20.9719 16.9995L20.9854 16.9758C21.2907 16.4261 21.1497 15.8722 20.981 15.4668C20.8199 15.0794 20.5435 14.6188 20.2371 14.1084L20.2062 14.0567L19.6281 13.0933C19.4603 12.8137 19.3903 12.6965 19.3271 12.5789C19.0178 12.0035 18.8074 11.3802 18.7047 10.7351C18.692 10.6553 18.6814 10.5742 18.667 10.4508C18.4494 10.4831 18.2268 10.4998 18.0002 10.4998C17.6501 10.4998 17.3093 10.4599 16.9822 10.3842C17.0128 10.6594 17.032 10.8289 17.0588 10.9972C17.1909 11.8267 17.4614 12.6281 17.859 13.3679C17.943 13.5243 18.0344 13.6766 18.1876 13.9319L18.199 13.9508L18.777 14.9142C19.1244 15.4932 19.3341 15.847 19.4422 16.1068L19.448 16.121L19.4328 16.1233C19.1544 16.1643 18.7431 16.1665 18.068 16.1665H5.93243C5.25724 16.1665 4.84598 16.1643 4.56758 16.1233L4.55239 16.121L4.55823 16.1068C4.6663 15.847 4.87602 15.4932 5.22339 14.9142L5.80143 13.9508L5.81279 13.9319L5.8128 13.9319C5.96597 13.6766 6.05737 13.5243 6.14141 13.3679C6.53901 12.6281 6.80951 11.8267 6.94162 10.9972C6.96955 10.8219 6.98917 10.6453 7.02204 10.3494L7.02447 10.3275L7.27628 8.06128C7.54373 5.65421 9.57831 3.83317 12.0002 3.83317C12.661 3.83317 13.293 3.96875 13.8681 4.21481C14.0953 3.68959 14.4197 3.21622 14.8187 2.8174ZM16.8413 4.36966C16.3322 4.73221 16.0002 5.32725 16.0002 5.99984C16.0002 6.00587 16.0002 6.0119 16.0003 6.01793C16.2769 6.44825 16.4866 6.92729 16.6136 7.44116C16.9732 7.78712 17.4618 7.99984 18.0002 7.99984C18.1336 7.99984 18.2639 7.98678 18.39 7.96187L18.3806 7.87723C18.2313 6.53359 17.6743 5.32515 16.8413 4.36966ZM19.4981 16.2805C19.498 16.2805 19.4977 16.2784 19.4976 16.2748C19.4982 16.2788 19.4983 16.2806 19.4981 16.2805ZM19.6106 16.0819C19.6105 16.0818 19.6086 16.0826 19.6053 16.0844C19.6068 16.0838 19.6079 16.0833 19.6088 16.0829C19.6101 16.0823 19.6107 16.0819 19.6106 16.0819ZM4.38979 16.0819C4.38993 16.0818 4.39185 16.0826 4.39512 16.0845C4.39129 16.0829 4.38965 16.082 4.38979 16.0819ZM4.5028 16.2747C4.50269 16.2784 4.50238 16.2805 4.50226 16.2805C4.50213 16.2806 4.50219 16.2788 4.5028 16.2747Z"
        fill="#1C1C1C"
      />
      <path
        d="M9.10222 17.6647C9.27315 18.6215 9.64978 19.467 10.1737 20.0701C10.6976 20.6731 11.3396 21 12 21C12.6604 21 13.3024 20.6731 13.8263 20.0701C14.3502 19.467 14.7269 18.6215 14.8978 17.6647"
        stroke="#1C1C1C"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <circle cx="18" cy="6" r="2.41667" fill="#1C1C1C" stroke="#1C1C1C" strokeWidth="0.833333" />
    </SvgIcon>
  );
};

export const ProfileIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <rect x="0.568359" width="24" height="24" rx="6" fill="#008B07" />
      <path
        d="M17.903 18V16.6667C17.903 15.9594 17.622 15.2811 17.1219 14.781C16.6218 14.281 15.9436 14 15.2363 14H9.90299C9.19575 14 8.51747 14.281 8.01738 14.781C7.51728 15.2811 7.23633 15.9594 7.23633 16.6667V18"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5671 11.3333C14.0398 11.3333 15.2337 10.1394 15.2337 8.66667C15.2337 7.19391 14.0398 6 12.5671 6C11.0943 6 9.90039 7.19391 9.90039 8.66667C9.90039 10.1394 11.0943 11.3333 12.5671 11.3333Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RecentSearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0013 17.7096C14.2585 17.7096 17.7096 14.2585 17.7096 10.0013C17.7096 5.74411 14.2585 2.29297 10.0013 2.29297C5.74411 2.29297 2.29297 5.74411 2.29297 10.0013C2.29297 14.2585 5.74411 17.7096 10.0013 17.7096Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.002 10.6854L7.50195 8.96875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.002 10.6863L13.4269 8.11133"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.85596 11.0772L6.07009 7.73411C5.74443 7.34331 6.02232 6.75 6.53103 6.75L11.469 6.75C11.9777 6.75 12.2556 7.34332 11.9299 7.73411L9.14404 11.0772C9.06908 11.1671 8.93092 11.1671 8.85596 11.0772Z"
        fill="#1C1C1C"
      />
    </SvgIcon>
  );
};

export const DashboardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M18.9766 2.75H6.47656C4.81971 2.75 3.47656 4.09315 3.47656 5.75V18.25C3.47656 19.9069 4.81971 21.25 6.47656 21.25H18.9766C20.6334 21.25 21.9766 19.9069 21.9766 18.25V5.75C21.9766 4.09315 20.6334 2.75 18.9766 2.75Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49658 12H9.10658L10.9966 15L14.4566 9L16.3466 12H17.9566"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FeedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5 17H6.5M17.5 13H6.5M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ExploreIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M20.7665 14.4698C21.4765 15.0798 20.9765 16.1098 19.9665 16.1098H12.5765V4.5498H19.9665C20.9765 4.5498 21.4765 5.5898 20.7665 6.1898L17.7565 8.7598C16.7465 9.6198 16.7465 11.0298 17.7565 11.8898L20.7665 14.4698Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.35657 10.9697V21.2497"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5466 14.06H5.37656C4.80656 14.06 4.34656 13.6 4.34656 13.03V3.78C4.34656 3.21 4.80656 2.75 5.37656 2.75H11.5466C12.1166 2.75 12.5766 3.21 12.5766 3.78V13.03C12.5766 13.6 12.1166 14.06 11.5466 14.06Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const PaymentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M16.7266 8.00032V4.50097C16.7266 3.66923 16.7266 3.25336 16.5514 2.99779C16.3983 2.7745 16.1612 2.62281 15.8943 2.5774C15.5888 2.52542 15.2113 2.69969 14.4561 3.04824L5.58558 7.14231C4.91207 7.45316 4.57531 7.60858 4.32867 7.84963C4.11062 8.06273 3.94418 8.32287 3.84207 8.61015C3.72656 8.9351 3.72656 9.306 3.72656 10.0478V15.0003M17.2266 14.5003H17.2366M3.72656 11.2003L3.72656 17.8003C3.72656 18.9204 3.72656 19.4805 3.94455 19.9083C4.1363 20.2846 4.44226 20.5906 4.81858 20.7823C5.2464 21.0003 5.80646 21.0003 6.92656 21.0003H18.5266C19.6467 21.0003 20.2067 21.0003 20.6345 20.7823C21.0109 20.5906 21.3168 20.2846 21.5086 19.9083C21.7266 19.4805 21.7266 18.9204 21.7266 17.8003V11.2003C21.7266 10.0802 21.7266 9.52016 21.5086 9.09234C21.3168 8.71601 21.0109 8.41005 20.6345 8.2183C20.2067 8.00032 19.6467 8.00032 18.5266 8.00032L6.92656 8.00032C5.80646 8.00032 5.24641 8.00032 4.81858 8.2183C4.44226 8.41005 4.1363 8.71601 3.94455 9.09234C3.72656 9.52016 3.72656 10.0802 3.72656 11.2003ZM17.7266 14.5003C17.7266 14.7765 17.5027 15.0003 17.2266 15.0003C16.9504 15.0003 16.7266 14.7765 16.7266 14.5003C16.7266 14.2242 16.9504 14.0003 17.2266 14.0003C17.5027 14.0003 17.7266 14.2242 17.7266 14.5003Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GoServiceIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 21V7C8 6.07003 8 5.60504 8.10222 5.22354C8.37962 4.18827 9.18827 3.37962 10.2235 3.10222C10.605 3 11.07 3 12 3C12.93 3 13.395 3 13.7765 3.10222C14.8117 3.37962 15.6204 4.18827 15.8978 5.22354C16 5.60504 16 6.07003 16 7C16 7 16 21.5 16 13.5M16 17.5C16 12.3367 16 21 16 21M6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6.8C5.11984 7 4.27976 7 3.63803 7.32698C3.07354 7.6146 2.6146 8.07354 2.32698 8.63803C2 9.27976 2 10.1198 2 11.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NetworkIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        id="Icon"
        d="M18.7265 15.8369C20.1824 16.5683 21.4307 17.742 22.3418 19.2096C22.5222 19.5003 22.6124 19.6456 22.6436 19.8468C22.707 20.2558 22.4273 20.7585 22.0465 20.9204C21.859 21 21.6482 21 21.2265 21M16.7265 11.5322C18.2082 10.7959 19.2265 9.26686 19.2265 7.5C19.2265 5.73314 18.2082 4.20411 16.7265 3.46776M14.7265 7.5C14.7265 9.98528 12.7118 12 10.2265 12C7.74124 12 5.72652 9.98528 5.72652 7.5C5.72652 5.01472 7.74124 3 10.2265 3C12.7118 3 14.7265 5.01472 14.7265 7.5ZM3.28575 18.9383C4.88006 16.5446 7.39589 15 10.2265 15C13.0571 15 15.573 16.5446 17.1673 18.9383C17.5166 19.4628 17.6912 19.725 17.6711 20.0599C17.6554 20.3207 17.4845 20.64 17.2761 20.7976C17.0084 21 16.6404 21 15.9042 21H4.54888C3.81269 21 3.4446 21 3.17696 20.7976C2.96857 20.64 2.79761 20.3207 2.78196 20.0599C2.76185 19.725 2.93648 19.4628 3.28575 18.9383Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GoStarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g id="star-01">
        <path
          id="Icon"
          d="M12.0092 3.45356C12.2397 2.98662 12.3549 2.75315 12.5114 2.67856C12.6475 2.61366 12.8056 2.61366 12.9418 2.67856C13.0982 2.75315 13.2135 2.98662 13.4439 3.45356L15.6306 7.88353C15.6987 8.02138 15.7327 8.0903 15.7824 8.14382C15.8264 8.1912 15.8792 8.22959 15.9379 8.25687C16.0041 8.28767 16.0802 8.29878 16.2323 8.32102L21.1236 9.03595C21.6386 9.11124 21.8962 9.14888 22.0153 9.27468C22.119 9.38414 22.1678 9.53454 22.1481 9.68402C22.1254 9.85582 21.9389 10.0374 21.566 10.4006L18.028 13.8467C17.9177 13.9541 17.8626 14.0078 17.827 14.0717C17.7955 14.1283 17.7753 14.1905 17.7675 14.2548C17.7587 14.3274 17.7717 14.4032 17.7977 14.555L18.6325 19.4224C18.7206 19.9357 18.7646 20.1924 18.6819 20.3447C18.6099 20.4773 18.4819 20.5702 18.3336 20.5977C18.1632 20.6293 17.9327 20.5081 17.4717 20.2657L13.0989 17.9661C12.9627 17.8944 12.8946 17.8586 12.8228 17.8445C12.7593 17.8321 12.6939 17.8321 12.6304 17.8445C12.5586 17.8586 12.4905 17.8944 12.3542 17.9661L7.98149 20.2657C7.52048 20.5081 7.28997 20.6293 7.11953 20.5977C6.97124 20.5702 6.84328 20.4773 6.7713 20.3447C6.68856 20.1924 6.73259 19.9357 6.82064 19.4224L7.65545 14.555C7.68147 14.4032 7.69449 14.3274 7.68568 14.2548C7.67789 14.1905 7.65767 14.1283 7.62617 14.0717C7.59058 14.0078 7.53544 13.9541 7.42515 13.8467L3.88712 10.4006C3.51423 10.0374 3.32778 9.85582 3.30509 9.68402C3.28535 9.53454 3.33412 9.38414 3.43781 9.27468C3.557 9.14888 3.81453 9.11124 4.32961 9.03595L9.22087 8.32102C9.37299 8.29878 9.44904 8.28767 9.51528 8.25687C9.57393 8.22959 9.62672 8.1912 9.67075 8.14382C9.72047 8.0903 9.75449 8.02138 9.82254 7.88353L12.0092 3.45356Z"
          stroke="#707070"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const ExpandMoreIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#111111"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ExpandLessIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 12.5L10 7.5L15 12.5"
        stroke="#111111"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ChatSNIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M8.22656 12H8.23656M12.7266 12H12.7366M17.2266 12H17.2366M12.7266 21C17.6971 21 21.7266 16.9706 21.7266 12C21.7266 7.02944 17.6971 3 12.7266 3C7.756 3 3.72656 7.02944 3.72656 12C3.72656 13.1971 3.9603 14.3397 4.38462 15.3845C4.46584 15.5845 4.50644 15.6845 4.52456 15.7653C4.54228 15.8443 4.54876 15.9028 4.54877 15.9839C4.54878 16.0667 4.53374 16.1569 4.50367 16.3374L3.91069 19.8952C3.84859 20.2678 3.81754 20.4541 3.87532 20.5888C3.92589 20.7067 4.01985 20.8007 4.13775 20.8512C4.27246 20.909 4.45874 20.878 4.83132 20.8159L8.38921 20.2229C8.56965 20.1928 8.65987 20.1778 8.74269 20.1778C8.82372 20.1778 8.88222 20.1843 8.96128 20.202C9.0421 20.2201 9.14209 20.2607 9.34205 20.3419C10.3869 20.7663 11.5294 21 12.7266 21ZM8.72656 12C8.72656 12.2761 8.5027 12.5 8.22656 12.5C7.95042 12.5 7.72656 12.2761 7.72656 12C7.72656 11.7239 7.95042 11.5 8.22656 11.5C8.5027 11.5 8.72656 11.7239 8.72656 12ZM13.2266 12C13.2266 12.2761 13.0027 12.5 12.7266 12.5C12.4504 12.5 12.2266 12.2761 12.2266 12C12.2266 11.7239 12.4504 11.5 12.7266 11.5C13.0027 11.5 13.2266 11.7239 13.2266 12ZM17.7266 12C17.7266 12.2761 17.5027 12.5 17.2266 12.5C16.9504 12.5 16.7266 12.2761 16.7266 12C16.7266 11.7239 16.9504 11.5 17.2266 11.5C17.5027 11.5 17.7266 11.7239 17.7266 12Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GinoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const GinoEndIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_34001_25465)">
        <path
          d="M3.75033 18.3337V14.167M3.75033 5.83366V1.66699M1.66699 3.75033H5.83366M1.66699 16.2503H5.83366M10.8337 2.50033L9.38851 6.25771C9.1535 6.86874 9.03599 7.17425 8.85327 7.43123C8.69132 7.65899 8.49232 7.85798 8.26456 8.01993C8.00758 8.20266 7.70207 8.32017 7.09104 8.55518L3.33366 10.0003L7.09104 11.4455C7.70207 11.6805 8.00758 11.798 8.26456 11.9807C8.49232 12.1427 8.69132 12.3417 8.85327 12.5694C9.036 12.8264 9.1535 13.1319 9.38851 13.7429L10.8337 17.5003L12.2788 13.7429C12.5138 13.1319 12.6313 12.8264 12.814 12.5694C12.976 12.3417 13.175 12.1427 13.4028 11.9807C13.6597 11.798 13.9652 11.6805 14.5763 11.4455L18.3337 10.0003L14.5763 8.55518C13.9652 8.32017 13.6597 8.20266 13.4028 8.01993C13.175 7.85798 12.976 7.65899 12.814 7.43123C12.6313 7.17425 12.5138 6.86873 12.2788 6.25771L10.8337 2.50033Z"
          stroke="url(#paint0_linear_34001_25465)"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_34001_25465"
          x1="1.66699"
          y1="10.0003"
          x2="18.3337"
          y2="10.0003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C4DED" />
          <stop offset="1" stopColor="#9D00EC" />
        </linearGradient>
        <clipPath id="clip0_34001_25465">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const SettingsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.5733 10.1282C15.2925 9.91245 15.154 9.56451 15.1675 9.21064C15.1702 9.14112 15.1716 9.0709 15.1716 9C15.1716 8.93922 15.1705 8.87895 15.1684 8.81918C15.1555 8.4488 15.2945 8.07979 15.5897 7.85566L16.8482 6.9C17.0025 6.78 17.0436 6.56 16.951 6.39L15.3053 3.62C15.2024 3.44 14.9864 3.38 14.8013 3.44L13.2693 4.03874C12.9489 4.16398 12.5898 4.1104 12.2972 3.92934C12.165 3.84754 12.0302 3.77091 11.8918 3.69947C11.574 3.53532 11.334 3.24181 11.2825 2.88781L11.0572 1.34C11.0263 1.14 10.8515 1 10.6458 1H7.35425C7.14853 1 6.98395 1.14 6.9531 1.34L6.7278 2.88781C6.67627 3.24181 6.43642 3.53561 6.1189 3.7004C5.97967 3.77266 5.84398 3.85002 5.71183 3.93173C5.4203 4.11198 5.06241 4.16437 4.74318 4.03961L3.20901 3.44C3.02386 3.37 2.80785 3.44 2.705 3.62L1.05924 6.39C0.956383 6.57 0.997527 6.78 1.1621 6.9L2.42062 7.85566C2.71578 8.07979 2.85166 8.44823 2.83312 8.81837C2.83008 8.8792 2.82843 8.93987 2.82843 9C2.82843 9.05985 2.82952 9.12023 2.8317 9.18078C2.84503 9.55115 2.70549 9.92021 2.41034 10.1443L1.15182 11.1C0.997526 11.22 0.956383 11.44 1.04896 11.61L2.69471 14.38C2.79757 14.56 3.01357 14.62 3.19872 14.56L4.73067 13.9613C5.05112 13.836 5.41024 13.8896 5.7028 14.0707C5.83497 14.1525 5.96984 14.2291 6.10818 14.3005C6.42603 14.4647 6.66599 14.7582 6.71752 15.1122L6.94281 16.66C6.98395 16.86 7.14853 17 7.35425 17H10.6458C10.8515 17 11.0263 16.86 11.0469 16.66L11.2722 15.1122C11.3237 14.7582 11.5636 14.4644 11.8811 14.2996C12.0203 14.2273 12.156 14.15 12.2882 14.0683C12.5797 13.888 12.9376 13.8356 13.2568 13.9604L14.791 14.56C14.9761 14.63 15.1921 14.56 15.295 14.38L16.9408 11.61C17.0436 11.43 17.0025 11.22 16.8379 11.1L15.5733 10.1282Z"
        stroke="#707070"
        strokeWidth="2"
      />
      <circle cx="9" cy="9" r="2" fill="#008B07" />
    </SvgIcon>
  );
};

export const ProfileViewsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.95093 10.5942C1.84106 10.4145 1.78612 10.3246 1.75536 10.186C1.73226 10.0819 1.73226 9.91775 1.75536 9.81366C1.78612 9.67507 1.84106 9.58522 1.95093 9.40552C2.85892 7.92054 5.56164 4.1665 9.68041 4.1665C13.7992 4.1665 16.5019 7.92054 17.4099 9.40552C17.5198 9.58522 17.5747 9.67507 17.6055 9.81366C17.6286 9.91775 17.6286 10.0819 17.6055 10.186C17.5747 10.3246 17.5198 10.4145 17.4099 10.5942C16.5019 12.0791 13.7992 15.8332 9.68041 15.8332C5.56164 15.8332 2.85892 12.0791 1.95093 10.5942Z"
        stroke="#111111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.68041 12.4998C11.0172 12.4998 12.1008 11.3805 12.1008 9.99984C12.1008 8.61913 11.0172 7.49984 9.68041 7.49984C8.34364 7.49984 7.25998 8.61913 7.25998 9.99984C7.25998 11.3805 8.34364 12.4998 9.68041 12.4998Z"
        stroke="#111111"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const PostsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.01526 17.9166L6.49247 16.138C6.77884 16.0242 6.92203 15.9673 7.05599 15.8931C7.17498 15.8271 7.28841 15.751 7.39511 15.6654C7.51523 15.5692 7.6237 15.4571 7.84066 15.233L16.9413 5.83326C17.8325 4.91279 17.8325 3.4204 16.9413 2.49993C16.0501 1.57945 14.6052 1.57945 13.714 2.49992L4.61342 11.8997C4.39646 12.1238 4.28798 12.2358 4.19477 12.3599C4.11198 12.4701 4.03826 12.5873 3.97439 12.7102C3.90248 12.8485 3.8474 12.9964 3.73726 13.2922L2.01526 17.9166ZM2.01526 17.9166L3.67577 13.4574C3.7946 13.1383 3.85401 12.9787 3.95591 12.9057C4.04497 12.8418 4.15517 12.8176 4.26166 12.8386C4.38352 12.8627 4.50055 12.9836 4.7346 13.2253L6.55726 15.1079C6.79132 15.3496 6.90834 15.4705 6.93161 15.5964C6.95195 15.7064 6.92857 15.8202 6.86673 15.9122C6.79597 16.0174 6.6415 16.0788 6.33256 16.2015L2.01526 17.9166Z"
        stroke="#1C1C1C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FollowersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.3277 17.5L17.7482 15M17.7482 15L15.3277 12.5M17.7482 15H12.9073M9.68005 12.9167H6.0494C4.92344 12.9167 4.36046 12.9167 3.90236 13.0602C2.87093 13.3834 2.06379 14.217 1.7509 15.2824C1.61194 15.7555 1.61194 16.337 1.61194 17.5M11.6971 6.25C11.6971 8.32107 10.0716 10 8.06643 10C6.06127 10 4.43578 8.32107 4.43578 6.25C4.43578 4.17893 6.06127 2.5 8.06643 2.5C10.0716 2.5 11.6971 4.17893 11.6971 6.25Z"
        stroke="#1C1C1C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FollowingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.3277 17.5L12.9073 15M12.9073 15L15.3277 12.5M12.9073 15H17.7482M9.68005 12.9167H6.0494C4.92344 12.9167 4.36046 12.9167 3.90236 13.0602C2.87093 13.3834 2.06379 14.217 1.7509 15.2824C1.61194 15.7555 1.61194 16.337 1.61194 17.5M11.6971 6.25C11.6971 8.32107 10.0716 10 8.06643 10C6.06127 10 4.43578 8.32107 4.43578 6.25C4.43578 4.17893 6.06127 2.5 8.06643 2.5C10.0716 2.5 11.6971 4.17893 11.6971 6.25Z"
        stroke="#1C1C1C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AppleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "101", height: "26", fill: "none" }}
      width="101"
      height="26"
      viewBox="0 0 101 26"
      fill="none"
    >
      <path
        d="M15.769 11.9964C15.7907 10.3154 16.6934 8.72478 18.1256 7.84432C17.2221 6.55399 15.7088 5.73589 14.1344 5.68663C12.4552 5.51037 10.8272 6.69146 9.97149 6.69146C9.09922 6.69146 7.78172 5.70413 6.36299 5.73332C4.51374 5.79307 2.78977 6.84445 1.89007 8.46119C-0.0439277 11.8096 1.39866 16.7307 3.25127 19.4373C4.17817 20.7626 5.26145 22.2431 6.6789 22.1906C8.06596 22.133 8.584 21.3061 10.2583 21.3061C11.9171 21.3061 12.4031 22.1906 13.8493 22.1572C15.3377 22.133 16.2754 20.826 17.1698 19.4881C17.8358 18.5437 18.3483 17.5 18.6882 16.3955C16.9391 15.6558 15.771 13.8955 15.769 11.9964Z"
        fill="black"
      />
      <path
        d="M13.0373 3.90664C13.8489 2.93243 14.2487 1.68025 14.1518 0.416016C12.912 0.546236 11.7668 1.1388 10.9443 2.07563C10.14 2.99096 9.72143 4.2211 9.80056 5.43702C11.0408 5.44979 12.2601 4.87329 13.0373 3.90664Z"
        fill="black"
      />
      <path
        d="M28.6508 0.710693V6.69971H30.8131C32.5978 6.69971 33.6312 5.59985 33.6312 3.68652C33.6312 1.80225 32.5895 0.710693 30.8131 0.710693H28.6508ZM29.5804 1.55737H30.7094C31.9503 1.55737 32.6849 2.34595 32.6849 3.69897C32.6849 5.07275 31.9628 5.85303 30.7094 5.85303H29.5804V1.55737Z"
        fill="black"
      />
      <path
        d="M36.7963 6.78687C38.1161 6.78687 38.9255 5.90283 38.9255 4.43774C38.9255 2.98096 38.112 2.09277 36.7963 2.09277C35.4765 2.09277 34.663 2.98096 34.663 4.43774C34.663 5.90283 35.4723 6.78687 36.7963 6.78687ZM36.7963 5.99414C36.0202 5.99414 35.5844 5.42554 35.5844 4.43774C35.5844 3.45825 36.0202 2.8855 36.7963 2.8855C37.5683 2.8855 38.0082 3.45825 38.0082 4.43774C38.0082 5.42139 37.5683 5.99414 36.7963 5.99414Z"
        fill="black"
      />
      <path
        d="M45.8176 2.17993H44.9253L44.1201 5.62891H44.0495L43.1198 2.17993H42.2649L41.3352 5.62891H41.2688L40.4594 2.17993H39.5547L40.7998 6.69971H41.717L42.6467 3.37109H42.7173L43.6511 6.69971H44.5766L45.8176 2.17993Z"
        fill="black"
      />
      <path
        d="M46.8452 6.69971H47.7376V4.05591C47.7376 3.35034 48.1568 2.9104 48.8167 2.9104C49.4766 2.9104 49.792 3.27148 49.792 3.9978V6.69971H50.6843V3.77368C50.6843 2.69873 50.1282 2.09277 49.1197 2.09277C48.439 2.09277 47.9907 2.39575 47.7708 2.89795H47.7044V2.17993H46.8452V6.69971Z"
        fill="black"
      />
      <path d="M52.0897 6.69971H52.982V0.416016H52.0897V6.69971Z" fill="black" />
      <path
        d="M56.338 6.78687C57.6578 6.78687 58.4672 5.90283 58.4672 4.43774C58.4672 2.98096 57.6537 2.09277 56.338 2.09277C55.0182 2.09277 54.2047 2.98096 54.2047 4.43774C54.2047 5.90283 55.014 6.78687 56.338 6.78687ZM56.338 5.99414C55.5619 5.99414 55.1261 5.42554 55.1261 4.43774C55.1261 3.45825 55.5619 2.8855 56.338 2.8855C57.11 2.8855 57.5499 3.45825 57.5499 4.43774C57.5499 5.42139 57.11 5.99414 56.338 5.99414Z"
        fill="black"
      />
      <path
        d="M61.1259 6.02319C60.6403 6.02319 60.2875 5.78662 60.2875 5.37988C60.2875 4.98145 60.5697 4.76978 61.1923 4.72827L62.2963 4.65771V5.0354C62.2963 5.5957 61.7983 6.02319 61.1259 6.02319ZM60.8976 6.77441C61.4911 6.77441 61.985 6.51709 62.2548 6.0647H62.3254V6.69971H63.1845V3.61182C63.1845 2.65723 62.5453 2.09277 61.4123 2.09277C60.3871 2.09277 59.6567 2.59082 59.5654 3.36694H60.4286C60.5282 3.04736 60.8727 2.86475 61.3708 2.86475C61.9809 2.86475 62.2963 3.13452 62.2963 3.61182V4.00195L61.0719 4.07251C59.997 4.13892 59.391 4.60791 59.391 5.42139C59.391 6.24731 60.026 6.77441 60.8976 6.77441Z"
        fill="black"
      />
      <path
        d="M66.2126 6.77441C66.8352 6.77441 67.3623 6.47974 67.6321 5.98584H67.7026V6.69971H68.5576V0.416016H67.6653V2.89795H67.5989C67.354 2.3999 66.831 2.10522 66.2126 2.10522C65.0713 2.10522 64.3366 3.01001 64.3366 4.43774C64.3366 5.86963 65.063 6.77441 66.2126 6.77441ZM66.4658 2.90625C67.2129 2.90625 67.6819 3.49976 67.6819 4.44189C67.6819 5.38818 67.217 5.97339 66.4658 5.97339C65.7104 5.97339 65.258 5.39648 65.258 4.43774C65.258 3.4873 65.7146 2.90625 66.4658 2.90625Z"
        fill="black"
      />
      <path
        d="M74.3441 6.78687C75.6639 6.78687 76.4732 5.90283 76.4732 4.43774C76.4732 2.98096 75.6597 2.09277 74.3441 2.09277C73.0242 2.09277 72.2108 2.98096 72.2108 4.43774C72.2108 5.90283 73.0201 6.78687 74.3441 6.78687ZM74.3441 5.99414C73.5679 5.99414 73.1322 5.42554 73.1322 4.43774C73.1322 3.45825 73.5679 2.8855 74.3441 2.8855C75.116 2.8855 75.556 3.45825 75.556 4.43774C75.556 5.42139 75.116 5.99414 74.3441 5.99414Z"
        fill="black"
      />
      <path
        d="M77.6544 6.69971H78.5468V4.05591C78.5468 3.35034 78.9659 2.9104 79.6259 2.9104C80.2858 2.9104 80.6012 3.27148 80.6012 3.9978V6.69971H81.4935V3.77368C81.4935 2.69873 80.9374 2.09277 79.9288 2.09277C79.2482 2.09277 78.7999 2.39575 78.58 2.89795H78.5135V2.17993H77.6544V6.69971Z"
        fill="black"
      />
      <path
        d="M85.6032 1.05518V2.20068H84.8852V2.9519H85.6032V5.50439C85.6032 6.37598 85.9975 6.72461 86.9895 6.72461C87.1638 6.72461 87.3298 6.70386 87.4751 6.67896V5.93604C87.3506 5.94849 87.2717 5.95679 87.1347 5.95679C86.6906 5.95679 86.4956 5.74927 86.4956 5.27612V2.9519H87.4751V2.20068H86.4956V1.05518H85.6032Z"
        fill="black"
      />
      <path
        d="M88.6729 6.69971H89.5652V4.06006C89.5652 3.37524 89.9719 2.91455 90.7024 2.91455C91.3333 2.91455 91.6695 3.27979 91.6695 4.00195V6.69971H92.5618V3.78198C92.5618 2.70703 91.9683 2.09692 91.0054 2.09692C90.3247 2.09692 89.8474 2.3999 89.6275 2.90625H89.5569V0.416016H88.6729V6.69971Z"
        fill="black"
      />
      <path
        d="M95.7808 2.85229C96.4407 2.85229 96.8724 3.31299 96.8931 4.02271H94.6104C94.6602 3.31714 95.1209 2.85229 95.7808 2.85229ZM96.889 5.47949C96.723 5.83228 96.3536 6.02734 95.814 6.02734C95.1002 6.02734 94.6395 5.52515 94.6104 4.73242V4.68262H97.8021V4.37134C97.8021 2.9519 97.0425 2.09277 95.785 2.09277C94.5108 2.09277 93.7015 3.01001 93.7015 4.45435C93.7015 5.89868 94.4942 6.78687 95.7891 6.78687C96.8226 6.78687 97.5447 6.28882 97.7481 5.47949H96.889Z"
        fill="black"
      />
      <path
        d="M72.7618 11.214V13.5051H71.3257V15.0075H72.7618V20.1125C72.7618 21.8556 73.5503 22.5529 75.5342 22.5529C75.8829 22.5529 76.2149 22.5114 76.5054 22.4616V20.9758C76.2564 21.0007 76.0987 21.0173 75.8248 21.0173C74.9366 21.0173 74.5464 20.6022 74.5464 19.6559V15.0075H76.5054V13.5051H74.5464V11.214H72.7618Z"
        fill="black"
      />
      <path
        d="M81.5593 22.6774C84.1989 22.6774 85.8176 20.9094 85.8176 17.9792C85.8176 15.0656 84.1906 13.2892 81.5593 13.2892C78.9196 13.2892 77.2927 15.0656 77.2927 17.9792C77.2927 20.9094 78.9113 22.6774 81.5593 22.6774ZM81.5593 21.092C80.007 21.092 79.1354 19.9548 79.1354 17.9792C79.1354 16.0202 80.007 14.8747 81.5593 14.8747C83.1032 14.8747 83.9831 16.0202 83.9831 17.9792C83.9831 19.9465 83.1032 21.092 81.5593 21.092Z"
        fill="black"
      />
      <path
        d="M87.2025 22.5031H88.9871V17.1657C88.9871 15.8957 89.9417 15.0407 91.2948 15.0407C91.6102 15.0407 92.1414 15.0988 92.2908 15.1486V13.3888C92.0999 13.339 91.7596 13.3141 91.494 13.3141C90.3153 13.3141 89.3109 13.9616 89.0535 14.8498H88.9207V13.4636H87.2025V22.5031Z"
        fill="black"
      />
      <path
        d="M96.7221 14.8083C98.042 14.8083 98.9052 15.7297 98.9467 17.1491H94.3813C94.4809 15.738 95.4023 14.8083 96.7221 14.8083ZM98.9384 20.0627C98.6064 20.7682 97.8676 21.1584 96.7885 21.1584C95.3608 21.1584 94.4394 20.154 94.3813 18.5685V18.4689H100.765V17.8464C100.765 15.0075 99.2456 13.2892 96.7304 13.2892C94.1821 13.2892 92.5634 15.1237 92.5634 18.0124C92.5634 20.9011 94.1489 22.6774 96.7387 22.6774C98.8056 22.6774 100.25 21.6813 100.657 20.0627H98.9384Z"
        fill="black"
      />
      <path
        d="M61.0582 19.1649C61.1958 21.3846 63.0456 22.8042 65.7987 22.8042C68.7411 22.8042 70.5823 21.3158 70.5823 18.9413C70.5823 17.0743 69.5326 16.0419 66.986 15.4482L65.618 15.1127C64.0006 14.7341 63.3467 14.2265 63.3467 13.3404C63.3467 12.2219 64.3619 11.4906 65.8848 11.4906C67.3301 11.4906 68.3282 12.2047 68.5088 13.349H70.3844C70.2725 11.2583 68.4314 9.78711 65.9106 9.78711C63.2005 9.78711 61.3937 11.2583 61.3937 13.4694C61.3937 15.2934 62.4175 16.3774 64.6631 16.9022L66.2633 17.2894C67.9066 17.6765 68.6293 18.2444 68.6293 19.1908C68.6293 20.292 67.4936 21.0921 65.945 21.0921C64.2845 21.0921 63.1316 20.3436 62.9682 19.1649H61.0582Z"
        fill="black"
      />
      <path
        d="M42.5709 13.3141C41.3423 13.3141 40.2798 13.9284 39.732 14.9577H39.5992V13.4636H37.8809V25.508H39.6656V21.1335H39.8067C40.2798 22.0881 41.3008 22.6525 42.5875 22.6525C44.8702 22.6525 46.3228 20.8513 46.3228 17.9792C46.3228 15.1071 44.8702 13.3141 42.5709 13.3141ZM42.0645 21.0505C40.5704 21.0505 39.6324 19.8718 39.6324 17.9875C39.6324 16.0949 40.5704 14.9162 42.0728 14.9162C43.5835 14.9162 44.4883 16.07 44.4883 17.9792C44.4883 19.8967 43.5835 21.0505 42.0645 21.0505Z"
        fill="black"
      />
      <path
        d="M52.5676 13.3141C51.3391 13.3141 50.2766 13.9284 49.7288 14.9577H49.596V13.4636H47.8777V25.508H49.6624V21.1335H49.8035C50.2766 22.0881 51.2976 22.6525 52.5842 22.6525C54.867 22.6525 56.3196 20.8513 56.3196 17.9792C56.3196 15.1071 54.867 13.3141 52.5676 13.3141ZM52.0613 21.0505C50.5672 21.0505 49.6292 19.8718 49.6292 17.9875C49.6292 16.0949 50.5672 14.9162 52.0696 14.9162C53.5803 14.9162 54.4851 16.07 54.4851 17.9792C54.4851 19.8967 53.5803 21.0505 52.0613 21.0505Z"
        fill="black"
      />
      <path
        d="M34.6789 22.5031H36.7265L32.2441 10.0882H30.1707L25.6882 22.5031H27.667L28.8113 19.208H33.5432L34.6789 22.5031ZM31.1084 12.3424H31.2547L33.0528 17.5905H29.3017L31.1084 12.3424Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const AndroidIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "116", height: "29", fill: "none" }}
      width="116"
      height="29"
      viewBox="0 0 116 29"
      fill="none"
    >
      <g filter="url(#filter0_ii_29403_15299)">
        <path
          d="M0.564563 2.05152C0.273563 2.35952 0.101562 2.83752 0.101562 3.45652V25.5725C0.101562 26.1925 0.273563 26.6695 0.564563 26.9775L0.638563 27.0495L13.0276 14.6605V14.5145V14.3685L0.638563 1.97852L0.564563 2.05152Z"
          fill="url(#paint0_linear_29403_15299)"
        />
        <path
          d="M17.1566 18.7913L13.0276 14.6603V14.5143V14.3683L17.1576 10.2383L17.2506 10.2913L22.1436 13.0713C23.5406 13.8653 23.5406 15.1643 22.1436 15.9593L17.2506 18.7393L17.1566 18.7913Z"
          fill="url(#paint1_linear_29403_15299)"
        />
        <g filter="url(#filter1_i_29403_15299)">
          <path
            d="M17.2506 18.7386L13.0266 14.5146L0.564576 26.9776C1.02458 27.4656 1.78558 27.5256 2.64258 27.0396L17.2506 18.7386Z"
            fill="url(#paint2_linear_29403_15299)"
          />
        </g>
        <path
          d="M17.2506 10.2904L2.64258 1.99037C1.78558 1.50337 1.02458 1.56437 0.564576 2.05237L13.0276 14.5154L17.2506 10.2904Z"
          fill="url(#paint3_linear_29403_15299)"
        />
      </g>
      <path
        d="M37.2573 4.24319C37.2573 5.08119 37.0093 5.74819 36.5123 6.24619C35.9483 6.83819 35.2123 7.13419 34.3083 7.13419C33.4423 7.13419 32.7053 6.83419 32.1003 6.23419C31.4943 5.63319 31.1913 4.88919 31.1913 4.00119C31.1913 3.11219 31.4943 2.36819 32.1003 1.76819C32.7053 1.16719 33.4423 0.867188 34.3083 0.867188C34.7383 0.867188 35.1493 0.951188 35.5393 1.11819C35.9303 1.28619 36.2433 1.50919 36.4773 1.78819L35.9503 2.31619C35.5533 1.84119 35.0063 1.60419 34.3073 1.60419C33.6753 1.60419 33.1293 1.82619 32.6683 2.27019C32.2073 2.71419 31.9773 3.29119 31.9773 4.00019C31.9773 4.70919 32.2073 5.28619 32.6683 5.73019C33.1293 6.17419 33.6753 6.39619 34.3073 6.39619C34.9773 6.39619 35.5363 6.17319 35.9833 5.72619C36.2733 5.43519 36.4413 5.03019 36.4863 4.51119H34.3073V3.79019H37.2143C37.2443 3.94719 37.2573 4.09819 37.2573 4.24319Z"
        fill="black"
      />
      <path
        d="M41.8674 1.73724H39.1354V3.63924H41.5994V4.36024H39.1354V6.26224H41.8674V7.00024H38.3644V1.00024H41.8674V1.73724Z"
        fill="black"
      />
      <path d="M45.1183 7.00024H44.3473V1.73724H42.6713V1.00024H46.7943V1.73724H45.1183V7.00024Z" fill="black" />
      <path d="M49.7772 7.00024V1.00024H50.5482V7.00024H49.7772Z" fill="black" />
      <path d="M53.9674 7.00024H53.1964V1.73724H51.5204V1.00024H55.6434V1.73724H53.9674V7.00024Z" fill="black" />
      <path
        d="M63.4482 6.22523C62.8582 6.83123 62.1252 7.13424 61.2482 7.13424C60.3712 7.13424 59.6382 6.83123 59.0492 6.22523C58.4592 5.61924 58.1652 4.87723 58.1652 4.00023C58.1652 3.12323 58.4592 2.38123 59.0492 1.77523C59.6382 1.16923 60.3712 0.865234 61.2482 0.865234C62.1202 0.865234 62.8522 1.17023 63.4442 1.77923C64.0362 2.38823 64.3322 3.12823 64.3322 4.00023C64.3322 4.87723 64.0372 5.61924 63.4482 6.22523ZM59.6182 5.72223C60.0622 6.17223 60.6052 6.39623 61.2482 6.39623C61.8912 6.39623 62.4352 6.17123 62.8782 5.72223C63.3222 5.27223 63.5452 4.69823 63.5452 4.00023C63.5452 3.30223 63.3222 2.72823 62.8782 2.27823C62.4352 1.82823 61.8912 1.60423 61.2482 1.60423C60.6052 1.60423 60.0622 1.82923 59.6182 2.27823C59.1752 2.72823 58.9522 3.30223 58.9522 4.00023C58.9522 4.69823 59.1752 5.27223 59.6182 5.72223Z"
        fill="black"
      />
      <path
        d="M65.4142 7.00024V1.00024H66.3522L69.2682 5.66724H69.3012L69.2682 4.51124V1.00024H70.0392V7.00024H69.2342L66.1832 2.10625H66.1502L66.1832 3.26224V7.00024H65.4142Z"
        fill="black"
      />
      <path
        d="M37.2573 4.24319C37.2573 5.08119 37.0093 5.74819 36.5123 6.24619C35.9483 6.83819 35.2123 7.13419 34.3083 7.13419C33.4423 7.13419 32.7053 6.83419 32.1003 6.23419C31.4943 5.63319 31.1913 4.88919 31.1913 4.00119C31.1913 3.11219 31.4943 2.36819 32.1003 1.76819C32.7053 1.16719 33.4423 0.867188 34.3083 0.867188C34.7383 0.867188 35.1493 0.951188 35.5393 1.11819C35.9303 1.28619 36.2433 1.50919 36.4773 1.78819L35.9503 2.31619C35.5533 1.84119 35.0063 1.60419 34.3073 1.60419C33.6753 1.60419 33.1293 1.82619 32.6683 2.27019C32.2073 2.71419 31.9773 3.29119 31.9773 4.00019C31.9773 4.70919 32.2073 5.28619 32.6683 5.73019C33.1293 6.17419 33.6753 6.39619 34.3073 6.39619C34.9773 6.39619 35.5363 6.17319 35.9833 5.72619C36.2733 5.43519 36.4413 5.03019 36.4863 4.51119H34.3073V3.79019H37.2143C37.2443 3.94719 37.2573 4.09819 37.2573 4.24319Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M41.8674 1.73724H39.1354V3.63924H41.5994V4.36024H39.1354V6.26224H41.8674V7.00024H38.3644V1.00024H41.8674V1.73724Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.1183 7.00024H44.3473V1.73724H42.6713V1.00024H46.7943V1.73724H45.1183V7.00024Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M49.7772 7.00024V1.00024H50.5482V7.00024H49.7772Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M53.9674 7.00024H53.1964V1.73724H51.5204V1.00024H55.6434V1.73724H53.9674V7.00024Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M63.4482 6.22523C62.8582 6.83123 62.1252 7.13424 61.2482 7.13424C60.3712 7.13424 59.6382 6.83123 59.0492 6.22523C58.4592 5.61924 58.1652 4.87723 58.1652 4.00023C58.1652 3.12323 58.4592 2.38123 59.0492 1.77523C59.6382 1.16923 60.3712 0.865234 61.2482 0.865234C62.1202 0.865234 62.8522 1.17023 63.4442 1.77923C64.0362 2.38823 64.3322 3.12823 64.3322 4.00023C64.3322 4.87723 64.0372 5.61924 63.4482 6.22523ZM59.6182 5.72223C60.0622 6.17223 60.6052 6.39623 61.2482 6.39623C61.8912 6.39623 62.4352 6.17123 62.8782 5.72223C63.3222 5.27223 63.5452 4.69823 63.5452 4.00023C63.5452 3.30223 63.3222 2.72823 62.8782 2.27823C62.4352 1.82823 61.8912 1.60423 61.2482 1.60423C60.6052 1.60423 60.0622 1.82923 59.6182 2.27823C59.1752 2.72823 58.9522 3.30223 58.9522 4.00023C58.9522 4.69823 59.1752 5.27223 59.6182 5.72223Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.4142 7.00024V1.00024H66.3522L69.2682 5.66724H69.3012L69.2682 4.51124V1.00024H70.0392V7.00024H69.2342L66.1832 2.10625H66.1502L66.1832 3.26224V7.00024H65.4142Z"
        stroke="black"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M58.2853 15.8378C55.9333 15.8378 54.0163 17.6268 54.0163 20.0908C54.0163 22.5398 55.9333 24.3438 58.2853 24.3438C60.6383 24.3438 62.5553 22.5398 62.5553 20.0908C62.5543 17.6268 60.6373 15.8378 58.2853 15.8378ZM58.2853 22.6698C56.9963 22.6698 55.8853 21.6068 55.8853 20.0918C55.8853 18.5608 56.9973 17.5138 58.2853 17.5138C59.5743 17.5138 60.6853 18.5608 60.6853 20.0918C60.6853 21.6058 59.5743 22.6698 58.2853 22.6698ZM48.9713 15.8378C46.6193 15.8378 44.7023 17.6268 44.7023 20.0908C44.7023 22.5398 46.6193 24.3438 48.9713 24.3438C51.3243 24.3438 53.2413 22.5398 53.2413 20.0908C53.2413 17.6268 51.3243 15.8378 48.9713 15.8378ZM48.9713 22.6698C47.6823 22.6698 46.5713 21.6068 46.5713 20.0918C46.5713 18.5608 47.6833 17.5138 48.9713 17.5138C50.2603 17.5138 51.3713 18.5608 51.3713 20.0918C51.3723 21.6058 50.2603 22.6698 48.9713 22.6698ZM37.8933 17.1438V18.9478H42.2113C42.0823 19.9628 41.7443 20.7038 41.2283 21.2188C40.6003 21.8468 39.6173 22.5398 37.8933 22.5398C35.2353 22.5398 33.1573 20.3968 33.1573 17.7388C33.1573 15.0808 35.2353 12.9378 37.8933 12.9378C39.3273 12.9378 40.3743 13.5018 41.1473 14.2268L42.4203 12.9538C41.3403 11.9228 39.9073 11.1338 37.8933 11.1338C34.2523 11.1338 31.1913 14.0978 31.1913 17.7388C31.1913 21.3798 34.2523 24.3438 37.8933 24.3438C39.8583 24.3438 41.3413 23.6988 42.5003 22.4908C43.6923 21.2988 44.0633 19.6228 44.0633 18.2698C44.0633 17.8518 44.0313 17.4648 43.9663 17.1428H37.8933V17.1438ZM83.2013 18.5448C82.8473 17.5948 81.7673 15.8378 79.5603 15.8378C77.3693 15.8378 75.5483 17.5618 75.5483 20.0908C75.5483 22.4748 77.3533 24.3438 79.7693 24.3438C81.7183 24.3438 82.8463 23.1518 83.3143 22.4588L81.8643 21.4918C81.3813 22.2008 80.7203 22.6678 79.7693 22.6678C78.8193 22.6678 78.1423 22.2328 77.7073 21.3788L83.3943 19.0268L83.2013 18.5448ZM77.4013 19.9628C77.3533 18.3188 78.6743 17.4818 79.6253 17.4818C80.3663 17.4818 80.9943 17.8528 81.2043 18.3838L77.4013 19.9628ZM72.7783 24.0868H74.6463V11.5858H72.7783V24.0868ZM69.7163 16.7888H69.6523C69.2333 16.2888 68.4273 15.8378 67.4133 15.8378C65.2863 15.8378 63.3373 17.7068 63.3373 20.1078C63.3373 22.4918 65.2863 24.3448 67.4133 24.3448C68.4283 24.3448 69.2333 23.8938 69.6523 23.3788H69.7163V23.9908C69.7163 25.6178 68.8463 26.4878 67.4453 26.4878C66.3013 26.4878 65.5923 25.6668 65.3023 24.9738L63.6753 25.6508C64.1423 26.7778 65.3823 28.1638 67.4453 28.1638C69.6363 28.1638 71.4893 26.8748 71.4893 23.7328V16.0968H69.7173V16.7888H69.7163ZM67.5743 22.6698C66.2853 22.6698 65.2063 21.5898 65.2063 20.1078C65.2063 18.6088 66.2853 17.5138 67.5743 17.5138C68.8463 17.5138 69.8453 18.6088 69.8453 20.1078C69.8453 21.5898 68.8463 22.6698 67.5743 22.6698ZM91.9553 11.5858H87.4843V24.0868H89.3493V19.3508H91.9543C94.0223 19.3508 96.0563 17.8538 96.0563 15.4688C96.0563 13.0838 94.0233 11.5858 91.9553 11.5858ZM92.0033 17.6108H89.3493V13.3258H92.0033C93.3983 13.3258 94.1903 14.4808 94.1903 15.4688C94.1903 16.4368 93.3983 17.6108 92.0033 17.6108ZM103.535 15.8158C102.184 15.8158 100.785 16.4108 100.206 17.7298L101.862 18.4208C102.216 17.7298 102.876 17.5038 103.567 17.5038C104.532 17.5038 105.513 18.0828 105.529 19.1118V19.2408C105.191 19.0478 104.467 18.7588 103.583 18.7588C101.798 18.7588 99.9803 19.7398 99.9803 21.5728C99.9803 23.2458 101.444 24.3228 103.084 24.3228C104.338 24.3228 105.03 23.7598 105.464 23.0998H105.528V24.0648H107.33V19.2718C107.331 17.0538 105.673 15.8158 103.535 15.8158ZM103.309 22.6668C102.699 22.6668 101.846 22.3608 101.846 21.6048C101.846 20.6398 102.908 20.2698 103.825 20.2698C104.644 20.2698 105.031 20.4468 105.529 20.6878C105.384 21.8468 104.387 22.6668 103.309 22.6668ZM113.892 16.0888L111.753 21.5088H111.689L109.469 16.0888H107.459L110.788 23.6638L108.89 27.8778H110.836L115.967 16.0888H113.892ZM97.0863 24.0868H98.9513V11.5858H97.0863V24.0868Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_ii_29403_15299"
          x="0.101562"
          y="1.6543"
          width="23.0898"
          height="25.7207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29403_15299" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_29403_15299" result="effect2_innerShadow_29403_15299" />
        </filter>
        <filter
          id="filter1_i_29403_15299"
          x="0.564575"
          y="14.5146"
          width="16.686"
          height="12.8604"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29403_15299" />
        </filter>
        <linearGradient
          id="paint0_linear_29403_15299"
          x1="11.9294"
          y1="3.22252"
          x2="-4.85264"
          y2="20.0045"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_29403_15299"
          x1="23.9621"
          y1="14.5143"
          x2="-0.233811"
          y2="14.5143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_29403_15299"
          x1="14.9567"
          y1="16.8085"
          x2="-7.80182"
          y2="39.5671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_29403_15299"
          x1="-2.57402"
          y1="-5.30983"
          x2="7.58828"
          y2="4.85247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export const GlobeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24px", height: "24px", fill: "#039103" }}
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#039103"
    >
      <path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" />
    </SvgIcon>
  );
};

export const EventsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.7266 10H3.72656M16.7266 2V6M8.72656 2V6M8.52656 22H16.9266C18.6067 22 19.4468 22 20.0885 21.673C20.653 21.3854 21.112 20.9265 21.3996 20.362C21.7266 19.7202 21.7266 18.8802 21.7266 17.2V8.8C21.7266 7.11984 21.7266 6.27976 21.3996 5.63803C21.112 5.07354 20.653 4.6146 20.0885 4.32698C19.4468 4 18.6067 4 16.9266 4H8.52656C6.84641 4 6.00633 4 5.36459 4.32698C4.8001 4.6146 4.34116 5.07354 4.05354 5.63803C3.72656 6.27976 3.72656 7.11984 3.72656 8.8V17.2C3.72656 18.8802 3.72656 19.7202 4.05354 20.362C4.34116 20.9265 4.8001 21.3854 5.36459 21.673C6.00633 22 6.8464 22 8.52656 22Z"
        stroke="#707070"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NotificationsNormalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.35418 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 11.0902 5.22047 13.206 4.34967 14.6054C3.61513 15.7859 3.24786 16.3761 3.26133 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38886 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NotificationsOnIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "22", fill: "none" }}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M8.35442 20C9.05956 20.6224 9.9858 21 11.0002 21C12.0147 21 12.9409 20.6224 13.6461 20M1.29414 4.81989C1.27979 3.36854 2.06227 2.01325 3.32635 1.3M20.7024 4.8199C20.7167 3.36855 19.9342 2.01325 18.6702 1.3M17.0002 7C17.0002 5.4087 16.3681 3.88258 15.2429 2.75736C14.1177 1.63214 12.5915 1 11.0002 1C9.40895 1 7.88283 1.63214 6.75761 2.75736C5.63239 3.88258 5.00025 5.4087 5.00025 7C5.00025 10.0902 4.22072 12.206 3.34991 13.6054C2.61538 14.7859 2.24811 15.3761 2.26157 15.5408C2.27649 15.7231 2.31511 15.7926 2.46203 15.9016C2.59471 16 3.19284 16 4.3891 16H17.6114C18.8077 16 19.4058 16 19.5385 15.9016C19.6854 15.7926 19.724 15.7231 19.7389 15.5408C19.7524 15.3761 19.3851 14.7859 18.6506 13.6054C17.7798 12.206 17.0002 10.0902 17.0002 7Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NoNotificationsFigure = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "76", height: "103", fill: "none" }}
      width="76"
      height="103"
      viewBox="0 0 76 103"
      fill="none"
    >
      <path
        d="M31.2396 98.5299C31.2396 98.5299 32.0186 100.16 33.5719 100.141C35.1251 100.122 35.6761 101.554 34.3319 102.1C32.9876 102.647 29.2351 101.201 29.2351 101.201L29.0879 98.3745L31.2396 98.5299Z"
        fill="#106048"
      />
      <path
        d="M15.318 98.5299C15.318 98.5299 14.539 100.16 12.9857 100.141C11.4324 100.122 10.8814 101.554 12.2304 102.1C13.5794 102.647 17.3272 101.201 17.3272 101.201L17.4745 98.3745L15.318 98.5299Z"
        fill="#106048"
      />
      <path
        d="M23.3408 15.7259C23.3408 15.7259 38.0658 17.5534 37.5623 37.4773C37.0588 57.4011 55.3463 61.3624 55.3463 61.3624L53.4083 65.9453C53.4083 65.9453 39.4623 63.6468 31.4586 50.1758C23.4548 36.7048 23.3408 15.7259 23.3408 15.7259Z"
        fill="#106048"
      />
      <path
        d="M23.3408 15.7259C23.3408 15.7259 38.0658 17.5534 37.5623 37.4773C37.0588 57.4011 55.3463 61.3624 55.3463 61.3624L53.4083 65.9453C53.4083 65.9453 39.4623 63.6468 31.4586 50.1758C23.4548 36.7048 23.3408 15.7259 23.3408 15.7259Z"
        fill="#9FBFB6"
      />
      <path d="M19.7973 5.18933L17.0518 15.3632L22.8135 16.4654L22.5 8.6183L19.7973 5.18933Z" fill="#F4A28C" />
      <path
        opacity="0.31"
        d="M22.6423 10.3327C21.936 10.0762 21.3203 9.6212 20.8706 9.02332C20.8706 9.02332 20.7518 10.9498 22.6756 13.0599L22.6423 10.3327Z"
        fill="#CE8172"
      />
      <path
        d="M16.6195 15.2407L23.925 15.8483C23.925 15.8483 38.3555 20.0545 37.776 33.5066C37.1965 46.9587 35.876 63.4348 35.876 63.4348L16.4675 65.9547C16.4675 65.9547 -15.823 22.4048 16.6195 15.2407Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M12.6814 22.8523C12.6814 22.8523 20.4144 27.2186 19.9299 35.3954C19.4454 43.5722 17.4883 52.8558 26.0004 51.9091C34.5124 50.9623 36.9254 48.2823 36.9254 48.2823L35.8471 63.4348L16.4386 65.9547L14.6906 63.4348C14.6906 63.4348 -1.72541 34.2367 12.6814 22.8523Z"
        fill="#111111"
      />
      <path d="M44.5132 38.0315L49.457 39.6187L52.3408 30.7864L47.397 29.1992L44.5132 38.0315Z" fill="#111111" />
      <path
        d="M44.0126 42.2109C44.0126 42.2109 48.6439 38.9421 47.5086 36.8979C46.3734 34.8537 41.8086 39.545 41.8086 39.545L44.0126 42.2109Z"
        fill="#F4A28C"
      />
      <path
        d="M16.4482 65.9547L35.8567 63.4348L32.185 98.7607H27.6582C27.6582 98.7607 27.9955 80.6456 25.2405 75.2713C22.4855 69.8971 16.4482 65.9547 16.4482 65.9547Z"
        fill="#111111"
      />
      <path
        d="M16.4486 65.9547L13.5986 98.7513H18.5576C18.5576 98.7513 22.0109 73.8959 30.9076 67.4854L16.4486 65.9547Z"
        fill="#111111"
      />
      <path
        d="M25.8681 5.38233C25.8681 5.38233 25.0226 8.48631 23.7733 10.2997C23.652 10.4751 23.4969 10.625 23.317 10.7408C23.137 10.8566 22.9358 10.936 22.7249 10.9745C22.5139 11.0131 22.2974 11.0099 22.0877 10.9652C21.878 10.9205 21.6792 10.8352 21.5028 10.7142C20.5908 10.0783 19.5411 8.95732 19.7928 7.23812L19.8546 4.27074C19.9302 3.67843 20.1892 3.12395 20.5958 2.68363C21.0024 2.2433 21.5367 1.93881 22.1251 1.81205C24.2958 1.20916 26.4761 3.51712 25.8681 5.38233Z"
        fill="#F4A28C"
      />
      <path
        d="M25.065 5.23162C24.1116 4.92705 23.1967 4.51455 22.3385 4.00228C22.4587 4.51098 22.426 5.04343 22.2445 5.53392C22.0631 6.02442 21.7407 6.45148 21.3173 6.76242C20.9132 7.07176 20.4133 7.23242 19.9031 7.21696C19.3928 7.20149 18.9038 7.01087 18.5195 6.67763L20.0015 2.81533C20.1961 2.25763 20.5381 1.76194 20.9918 1.38001C21.4455 0.998067 21.9942 0.743875 22.5808 0.643956C23.09 0.559114 23.6039 0.50563 24.1198 0.483812C25.4118 0.446131 26.7893 1.78852 28.0765 1.42584C28.2057 1.38722 28.3427 1.38251 28.4742 1.41218C28.6057 1.44184 28.7273 1.50486 28.8268 1.59507C28.9264 1.68527 29.0007 1.79958 29.0423 1.92678C29.084 2.05399 29.0917 2.18975 29.0645 2.32076C28.8033 3.56424 27.9055 5.34467 26.0578 5.4059C25.7192 5.40473 25.3834 5.34578 25.065 5.23162Z"
        fill="#111111"
      />
      <path
        d="M21.6776 6.79075C21.6776 6.79075 22.0814 5.62264 21.1694 5.37772C20.2574 5.13279 19.6589 6.83786 20.7989 7.42662L21.6776 6.79075Z"
        fill="#F4A28C"
      />
      <path
        d="M25.2311 7.3089L25.6491 8.77845C25.6724 8.86193 25.6742 8.94986 25.6543 9.03421C25.6345 9.11855 25.5937 9.19663 25.5355 9.26128C25.4774 9.32594 25.4039 9.37512 25.3217 9.40432C25.2394 9.43352 25.1511 9.44182 25.0648 9.42845L23.8203 9.2212L25.2311 7.3089Z"
        fill="#F4A28C"
      />
      <path
        d="M13.2331 24.0487C12.9511 23.1533 12.4261 22.3519 11.7157 21.7324C11.0052 21.1129 10.1366 20.6991 9.20492 20.5362C8.27321 20.3733 7.31427 20.4676 6.43299 20.8088C5.55171 21.15 4.78202 21.725 4.20814 22.4708C2.07539 25.2357 0.21339 29.3335 0.71689 35.094C1.80939 47.4816 5.66639 61.791 14.4919 59.987C23.3174 58.183 44.8064 43.153 44.8064 43.153L41.8566 39.5451C41.8566 39.5451 23.8304 49.2856 17.0759 48.2023C11.5754 47.3262 16.3254 33.9494 13.2331 24.0487Z"
        fill="#106048"
      />
      <path
        d="M13.2331 24.0487C12.9511 23.1533 12.4261 22.3519 11.7157 21.7324C11.0052 21.1129 10.1366 20.6991 9.20492 20.5362C8.27321 20.3733 7.31427 20.4676 6.43299 20.8088C5.55171 21.15 4.78202 21.725 4.20814 22.4708C2.07539 25.2357 0.21339 29.3335 0.71689 35.094C1.80939 47.4816 5.66639 61.791 14.4919 59.987C23.3174 58.183 44.8064 43.153 44.8064 43.153L41.8566 39.5451C41.8566 39.5451 23.8304 49.2856 17.0759 48.2023C11.5754 47.3262 16.3254 33.9494 13.2331 24.0487Z"
        fill="#9FBFB6"
      />
      <path
        d="M55.0425 62.0971C55.0425 62.0971 60.1392 61.5507 60.0205 64.0754C59.9017 66.6 53.9072 64.7772 53.9072 64.7772L55.0425 62.0971Z"
        fill="#F4A28C"
      />
      <path d="M70.1639 2.02032H45V21.4517H70.1639V2.02032Z" fill="#106048" />
      <path d="M47.9766 20.0037L50.039 27.5814L51.9878 20.0037H47.9766Z" fill="#106048" />
      <path
        d="M70.5396 25.1438C73.0494 25.1438 75.084 23.1298 75.084 20.6453C75.084 18.1608 73.0494 16.1468 70.5396 16.1468C68.0297 16.1468 65.9951 18.1608 65.9951 20.6453C65.9951 23.1298 68.0297 25.1438 70.5396 25.1438Z"
        fill="#A0A0A0"
      />
      <path d="M71.2726 18.6459V22.5897H70.4374V19.4347L69.5283 19.9981V19.26L70.5056 18.6459H71.2726Z" fill="white" />
      <path
        d="M57.2115 6.60352H57.7988C58.7348 6.60352 59.6323 6.97015 60.2941 7.62276C60.9559 8.27537 61.3277 9.16051 61.3277 10.0834V14.152H53.6826V10.0834C53.6826 9.16051 54.0544 8.27537 54.7162 7.62276C55.378 6.97015 56.2756 6.60352 57.2115 6.60352Z"
        fill="white"
      />
      <path
        d="M57.5765 17.7053C58.4477 17.7053 59.1539 17.0089 59.1539 16.1497C59.1539 15.2906 58.4477 14.5942 57.5765 14.5942C56.7053 14.5942 55.999 15.2906 55.999 16.1497C55.999 17.0089 56.7053 17.7053 57.5765 17.7053Z"
        fill="#707070"
      />
      <path
        d="M57.5765 17.7053C58.4477 17.7053 59.1539 17.0089 59.1539 16.1497C59.1539 15.2906 58.4477 14.5942 57.5765 14.5942C56.7053 14.5942 55.999 15.2906 55.999 16.1497C55.999 17.0089 56.7053 17.7053 57.5765 17.7053Z"
        fill="white"
      />
      <path
        d="M61.1816 13.1994H53.793C53.1204 13.1994 52.5752 13.7371 52.5752 14.4004V14.6013C52.5752 15.2646 53.1204 15.8023 53.793 15.8023H61.1816C61.8542 15.8023 62.3995 15.2646 62.3995 14.6013V14.4004C62.3995 13.7371 61.8542 13.1994 61.1816 13.1994Z"
        fill="#707070"
      />
      <path
        opacity="0.63"
        d="M61.1816 13.1994H53.793C53.1204 13.1994 52.5752 13.7371 52.5752 14.4004V14.6013C52.5752 15.2646 53.1204 15.8023 53.793 15.8023H61.1816C61.8542 15.8023 62.3995 15.2646 62.3995 14.6013V14.4004C62.3995 13.7371 61.8542 13.1994 61.1816 13.1994Z"
        fill="white"
      />
      <path
        d="M57.5761 7.09998C58.1811 7.09998 58.6716 6.61627 58.6716 6.0196C58.6716 5.42292 58.1811 4.93921 57.5761 4.93921C56.971 4.93921 56.4805 5.42292 56.4805 6.0196C56.4805 6.61627 56.971 7.09998 57.5761 7.09998Z"
        fill="#707070"
      />
      <path
        d="M57.5761 7.09998C58.1811 7.09998 58.6716 6.61627 58.6716 6.0196C58.6716 5.42292 58.1811 4.93921 57.5761 4.93921C56.971 4.93921 56.4805 5.42292 56.4805 6.0196C56.4805 6.61627 56.971 7.09998 57.5761 7.09998Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const VerifiedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "17", fill: "none" }}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.91667 0.00251055C5.71808 -0.0174772 3.52003 0.0818966 1.33227 0.300191C0.976969 0.315804 0.64109 0.466302 0.393409 0.720871C0.145728 0.975441 0.0049863 1.31482 0 1.66952C0.00477519 4.00333 -0.0495469 9.06748 0.762235 10.9351C1.53978 12.3065 2.54072 13.5393 3.72405 14.5829C4.58597 15.3223 6.67213 16.6667 7.91667 16.6667C9.1612 16.6667 11.2474 15.3194 12.1099 14.5829C13.2933 13.5393 14.2942 12.3066 15.0717 10.9351C15.8817 9.07224 15.773 4.02893 15.8333 1.68738C15.8258 1.33166 15.6827 0.992158 15.4333 0.737823C15.1838 0.483488 14.8467 0.333401 14.4903 0.318051C12.3059 0.100843 10.1118 -0.00447508 7.91667 0.00251055Z"
        fill="#008B07"
      />
      <path
        d="M4.75 7.40734L7.21296 10.0528L12.1389 4.76184"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ShowSideNavButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="14" viewBox="0 0 20 14" fill="none">
      <path d="M1 7H19M1 1H19M1 13H19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
